import { LoginRepository } from '@/Account/domain/LoginRepository'
import { LoginModel } from '../domain/LoginModel'
import { LoginForm } from '@/Account/ui/hooks'
import { HttpModel } from '@/Shared/domain'

interface ILogin {
  login: (data: LoginForm) => Promise<HttpModel<LoginModel>>
  validateOtp: (otp: string, guid: string) => Promise<HttpModel<boolean>>
  resendOtp: () => Promise<HttpModel<string>>
}

export const LoginContract = (LoginRepository: LoginRepository): ILogin => ({
  login: async (data: LoginForm): Promise<HttpModel<LoginModel>> =>
    await LoginRepository.Login(data),
  validateOtp: async (otp: string, guid: string): Promise<HttpModel<boolean>> =>
    await LoginRepository.ValidateOtp(otp, guid),
  resendOtp: async (): Promise<HttpModel<string>> => await LoginRepository.ResendOtp(),
})
